import { fetchPost, fetchGet , fetchPut , fetchDelete} from '@/utils/request'


export function getPageTdkslist (query) {  //页面tdk配置列表
    return fetchGet('/gateway/v1/page-tdks',query)
}
export function creatPageTdks (query) { //页面tdk配置添加
    return fetchPost('/gateway/v1/page-tdks',query)
}
export function getPageTdksDetail (id) {  //页面tdk详情
    return fetchGet('/gateway/v1/page-tdks/'+id)
}
export function editPageTdks (id,query) {  //页面tdk修改
    return fetchPut('/gateway/v1/page-tdks/'+id,query)
}
export function deletePageTdks (id) { //页面tdk删除
    return fetchDelete('/gateway/v1/page-tdks/'+id)
}
export function getPageTdksRules (query) {  //调用字段规则列表
    return fetchGet('/gateway/v1/page-tdk-rules',query)
}